import UserList from "@/modules/system/pages/user/List";
import UserEdit from '@/modules/system/pages/user/Edit';
import ChangePassword from '@/modules/system/pages/user/ChangePassword';

import RoleList from "@/modules/system/pages/role/List";
import RoleEdit from '@/modules/system/pages/role/Edit';
import LogList from "@/modules/system/pages/log/List";

export default [
    {
        path: '/user',
        name: 'UserList',
        component: UserList,
        meta: {
            caption: '用户管理',
        }
    },
    {
        path: '/user/edit',
        name: 'UserEdit',
        component: UserEdit,
        meta: {
            caption: '用户编辑'
        }
    },
    {
        path: '/user/changePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
            caption: '修改密码'
        }
    },
    {
        path: '/role',
        name: 'RoleList',
        component: RoleList,
        meta: {
            caption: '角色管理'
        }
    },
    {
        path: '/role/edit',
        name: 'RoleEdit',
        component: RoleEdit,
        meta: {
            caption: '角色编辑'
        }
    },
    {
        path: '/log',
        name: 'LogList',
        component: LogList,
        meta: {
            caption: '操作日志'
        }
    }
];



// WEBPACK FOOTER //
// ./src/modules/system/router.js